import { render, staticRenderFns } from "./BranchAdminProvinsi.vue?vue&type=template&id=1a6c0d4c&"
import script from "./BranchAdminProvinsi.vue?vue&type=script&lang=js&"
export * from "./BranchAdminProvinsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports